import { render } from "./MyDatabase.vue?vue&type=template&id=909f509a&scoped=true"
import script from "./MyDatabase.vue?vue&type=script&lang=js"
export * from "./MyDatabase.vue?vue&type=script&lang=js"

import "./MyDatabase.vue?vue&type=style&index=0&id=909f509a&scoped=true&lang=css"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-909f509a"]])

export default __exports__